import { type ReactNode } from 'react';
import { Settings } from 'lucide-react';
import { SettingsCard } from './settings-card';
import { PipelineToggle } from './pipeline-toggle';
import { RegistrationToggle } from './registration-toggle';
import { StreakToggle } from './streak-toggle';
import { DistributeLoadButton } from './distribute-load-button';
import { BulkResetStreaksButton } from './bulk-reset-streaks-button';

function Toggles(): ReactNode {
  return (
    <div className="col-span-full space-y-sm">
      <RegistrationToggle />
      <StreakToggle />
      <PipelineToggle />
    </div>
  );
}

function Actions(): ReactNode {
  return (
    <div className="col-span-full flex flex-wrap gap-sm border-t border-white/[0.06] pt-sm">
      <DistributeLoadButton role="approacher" />
      <DistributeLoadButton role="mago" />
      <BulkResetStreaksButton />
    </div>
  );
}

export function SystemCard(): ReactNode {
  return (
    <div className="self-start">
      <SettingsCard
        icon={<Settings size={16} />}
        title="Sistema"
        subtitle="Motores, pipeline y herramientas"
      >
        <Toggles />
        <Actions />
      </SettingsCard>
    </div>
  );
}
